(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-greeting-input.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-greeting-input.js');
"use strict";

const {
  useMemo,
  useEffect
} = React;
const {
  ControlGroup,
  Select,
  Option
} = svs.ui.reactForm;
const PersonalGreetingInput = _ref => {
  var _personalGreetingsOpt;
  let {
    onInputChange,
    name,
    value
  } = _ref;
  const personalGreetingsOptions = useMemo(() => (svs.tickets_giftshop.data.moduleConfig.greetings || []).filter(_ref2 => {
    let {
      greeting
    } = _ref2;
    return Boolean(greeting);
  }).map((_ref3, i) => {
    let {
      greeting
    } = _ref3;
    return {
      greeting,
      id: "".concat(greeting, "_").concat(i)
    };
  }));
  const hasOptions = (personalGreetingsOptions === null || personalGreetingsOptions === void 0 ? void 0 : personalGreetingsOptions.length) > 0;
  const defaultValue = hasOptions && ((_personalGreetingsOpt = personalGreetingsOptions[0]) === null || _personalGreetingsOpt === void 0 ? void 0 : _personalGreetingsOpt.greeting);
  useEffect(() => {
    const greetingExist = personalGreetingsOptions === null || personalGreetingsOptions === void 0 ? void 0 : personalGreetingsOptions.find(_ref4 => {
      let {
        greeting
      } = _ref4;
      return greeting === value;
    });
    if (!greetingExist) {
      onInputChange && onInputChange({
        target: {
          value: defaultValue,
          name
        }
      });
    }
  }, []);
  return hasOptions && React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    label: "V\xE4lj en rubrik",
    onChange: e => {
      onInputChange({
        target: {
          value: e.target.value,
          name
        }
      });
    },
    v2: true,
    value: value || defaultValue
  }, personalGreetingsOptions.map(_ref5 => {
    let {
      greeting,
      id
    } = _ref5;
    return React.createElement(Option, {
      id: id,
      key: id,
      name: greeting,
      value: greeting
    }, greeting);
  })));
};
svs.tickets_giftshop.gift.giftform.components.PersonalGreetingInput = PersonalGreetingInput;

 })(window);